import { render, staticRenderFns } from "./TemplateDefault.vue?vue&type=template&id=6320ff51"
import script from "./TemplateDefault.vue?vue&type=script&lang=js"
export * from "./TemplateDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports